import { render, staticRenderFns } from "./AppPrivate.vue?vue&type=template&id=2257761c"
import script from "./AppPrivate.vue?vue&type=script&lang=js"
export * from "./AppPrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports